import {
  FETCH_SITES,
  FETCH_SITES_REQUEST,
  FETCH_SITES_SUCCESS,
  FETCH_SITES_FAILURE,
  RESET_SITE_SEARCH,
  SHOW_RESULTS

} from './constants';

export function fetchSites({trial_id,language, lat,lng,radius, country, place}) {
  return {
    type: FETCH_SITES,
    trial_id,
    language,
    lat,
    lng,
    radius,
    country,
    place
  };
}
export function fetchSitesRequest() {
  return {
    type: FETCH_SITES_REQUEST
  };
}

export function fetchSitesError(message) {
  return {
    type: FETCH_SITES_FAILURE,
    message,
  };
}

export function fetchSitesSuccess({data}) {
  return {
    type: FETCH_SITES_SUCCESS,
    data
  };
}

export function resetSiteSearch() {
  return {
    type: RESET_SITE_SEARCH
  }
}

export function showResults(show) {
  return {
    type: SHOW_RESULTS,
    show
  }
}
